var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/_design platform") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/_design-platform",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    opacity: 0,
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(34.000000, 18.921000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#1B9AD2",
    points: "61.9104293 120.7292 0.764648761 78.3250558 0.764648761 61.4514428 61.9120756 103.848209 123.167337 61.4555417 123.167337 78.316858"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#467EC0",
    points: "61.9104293 153.791579 0.764648761 111.343166 0.764648761 94.4605354 61.9120756 136.910588 123.167337 94.4129879 123.167337 111.29152"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#41C3DE",
    points: "123.167337 35.6389875 72.4955532 0.0365903191 72.4955532 16.9766059 106.55662 40.311756 72.4955532 63.6649414 72.548236 80.5738052 123.167337 44.9804256"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#41C3DE",
    points: "51.3273632 0.0732346617 0.764237176 35.5993919 0.764237176 45.0195293 51.3273632 80.5735592 51.3273632 63.6278052 17.318156 40.3115101 51.3273632 17.01407"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignPlatform);
export default __webpack_public_path__ + "1be97d4cab2130b96eeeb1647dc3ac8d.svg";
export { ForwardRef as ReactComponent };